import React, {useEffect} from "react";
import LoadingSpinner from "../GUI_COMMON/COMPONENTS/LoadingSpinner";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useParams} from "react-router-dom";
import ArchiverClientApi from "../API/archiverClientApi";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import Header from "./Header";
import BackButton from "../GUI_COMMON/COMPONENTS/BackButton";
import {useCookies} from "react-cookie";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import ReactDOMServer from "react-dom/server";
import {useHistory} from "react-router";
import type {BTOBox} from "./BTOAddUpdatePage";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import LIButton from "../GUI_COMMON/COMPONENTS/LIButton";

class BoxHistoryItem {
    id: number;
    date: string;
    actionVerb: string;
    actor: string;
    note: string;
}

export const BoxHistoryPage = () => {
    
    const [globalState] = React.useContext(StoreContext);
    const [isSearchingHistory, setIsSearchingHistory] = React.useState(false);
    const [boxHistory:BoxHistoryItem[], setBoxHistory] = React.useState([]);
    const [boxInfo:BTOBox, setBoxBasicInfo] = React.useState(null);

    const {boxBC} = useParams();
    const [cookies,]= useCookies();
    const history = useHistory();

    useEffect(() => {
        // RECALL -- this runs AFTER all children mount!
        console.debug("BoxHistoryPage starting up...");
        window.scrollTo(0,0);
        LIUtils.setBackgroundColor('--li-main-bg-color');

        getBoxInfo(boxBC);
        getBoxHistory(boxBC);

    }, [boxBC]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    function getBoxInfo(boxBC:string) {
        ArchiverClientApi.sendBoxSearchRequest(boxBC,0,1)
        .then( (results) => { // returns a single result
            setBoxBasicInfo(results[0]);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError));
    }
    
    function getBoxHistory(boxBC:string) {
        setIsSearchingHistory(true);
        setBoxHistory([]);
        ArchiverClientApi.getBoxHistory(boxBC)
        .then( (boxHistory:BoxHistoryItem[]) => {
            setBoxHistory(boxHistory);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => setIsSearchingHistory(false));
    }

    function historyLinkClickHandler(note: Element, sampleId: number) {
        if(!note) return;
        Popup.showInfo(ReactDOMServer.renderToString(note), true);
    }

    function showHistoryTable() {
        if (boxHistory.length === 0) {
            return <div className="card">{isSearchingHistory?<LoadingSpinner medium center/>:"No history found"}</div>;
        }

        const resultList = boxHistory.map((item, index) =>
            <tr className="text-left" key={item.id}>
                <td width="200px">{LIUtils.shortDateTimeFromJsonUtcDateStr(item.date)}</td>
                <td width="250px">{item.actionVerb}</td>
                <td>{item.actor}</td>
                <td style={{whiteSpace: 'pre-line'}}>
                    {LIUtils.translateHistoryNote(item.note, LIUtils.UserCanSeeSampleLocation(cookies), historyLinkClickHandler)}
                </td>
            </tr>
        );

        return (
            <table className="table table-striped">
                <thead>
                    <tr className="text-left"><th width="160px">Date</th><th className="50px text-wrap">Action</th><th width="200px">Who</th><th>Note</th></tr>
                </thead>
                <tbody>
                    {resultList}
                </tbody>
            </table>
        );
    }

    function handleMoveToAnotherLocationClicked() {
        history.push(`/admin/box_move/${boxBC}`);
    }
    
    function doMagSearchForBox(boxBC:string) {
        history.push(`/mag_search?s=${boxBC}&t=&si=0&nr=20`, {replace: false});
    }
    
    return (<div className="container">
                <Header title={"Box History - "+boxBC}/>
                <div className="row mt-3 li-header-row justify-content-between">
                    <div>
                        <span style={{verticalAlign:"top"}}><BackButton/></span>
                        <div className="d-inline-block">
                            <div className="">
                                <span className="li-font-huge m-0 p-0">Box History:</span>
                                <span className="li-font-large li-fg-primary ml-2 align-self-center">{boxBC??"-"}</span>
                            </div>
                            <div className="m-0 p-0">
                                <span className="li-font-medium ml-0 font-weight-bold">Stored at: </span>
                                <span className="li-font-medium li-fg-slightly-muted">
                                    {ArchiverGuiUtils.GetLocationBasedOnDeptId(boxInfo?.storageLocationId, globalState.locations)}
                                        {/* show a move icon if the person has the admin permission */}
                                        {LIUtils.UserHasLevel(cookies,"SERVICE") &&
                                            <i className="li-font-medium ml-3 li-fg-primary fa fa-exchange li-pointer"
                                               data-toggle="tooltip" data-placement="auto" title="Move to another location"
                                               onClick={handleMoveToAnotherLocationClicked}/>}
                                </span>
                            </div>
                        </div>
                    </div>
                    <LIButton bgClass="li-primary" label="Show Child Mags" onClick={() => doMagSearchForBox(boxBC)} tooltip="Show Child Mags"></LIButton>
                    {/*<div className="li-font-small text-right my-auto ml-auto mr-3">[id: {boxId}]</div>*/}
                </div>
            
                <div className="mb-5">
                    <div className="li-font-huge">History</div>
                    <div className="li-search-results-table">
                        {showHistoryTable()}
                    </div>
                </div>
            </div>
        );
};